import { AiOutlineArrowRight } from "react-icons/ai";
import { useNavigate, useSearchParams } from "react-router-dom";

import AddButton from "@Components/AddButton";
import TextFilter from "@Components/Filters/TextFilter";
import UserFirstNameLastNameFilter from "@Components/Filters/UserFirstNameLastNameFilter";
import IconButton from "@Components/IconButton";
import Table from "@Components/Table";
import { Column } from "@Components/Table/types";
import useCurrentUser from "@Hooks/useCurrentUser";
import useMembers from "@Hooks/useUsers";
import { User } from "@Types/users";

import styles from "./Users.module.scss";

const Users = () => {
  const currentUser = useCurrentUser();
  const [searchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;
  const columns: Column<User>[] = [
    {
      id: "name",
      label: "Name",
      value: (user) =>
        `${user?.data?.info?.firstName ?? "First name"} ${
          user?.data?.info?.lastName ?? ""
        }`,
      sortPath: ["data", "info", "firstName"],
      filters: [
        {
          placeholder: "Name",
          preview: UserFirstNameLastNameFilter,
          queryPath: [],
        },
      ],
    },

    {
      id: "email",
      label: "Email",
      value: (user) => user.data.info.email ?? "",
      sortPath: ["data", "info", "email"],
      filters: [
        {
          placeholder: "Email",
          preview: TextFilter,
          queryPath: ["data", "info", "email"],
          partialSearch: true,
          caseInsensitive: true,
        },
      ],
    },

    {
      id: "string",
      label: "User type",
      sortPath: ["data", "info", "userType"],
      value: (user) =>
        user?.data?.info?.userType === "lender-admin" ? "Admin" : "User",
      filters: [
        {
          placeholder: "User type",
          preview: TextFilter,
          queryPath: ["data", "info", "userType"],
          partialSearch: true,
          caseInsensitive: true,
        },
      ],
    },

    {
      id: "actions",
      label: "Actions",
      value: (user) => (
        <IconButton
          id={`open-user-${user?._id}`}
          className={"blueCircle"}
          onClick={() => {
            navigate(`/users/${user._id}?page=${currentPage}`);
          }}
        >
          <AiOutlineArrowRight size={18} />
        </IconButton>
      ),
    },
  ];

  const navigate = useNavigate();

  return (
    <div className={styles.tableContainer}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
        }}
      >
        <h2 className={styles.title}>Users</h2>

        {currentUser?.data.info.userType === "lender-admin" && (
          <AddButton entity="user" id="create-new-user" />
        )}
      </div>
      <Table<User>
        columns={columns}
        useGetFunction={useMembers}
        entityType="users"
      />
    </div>
  );
};

export default Users;
